import { Injectable } from '@angular/core';
// import { BLE } from '@awesome-cordova-plugins/ble/ngx';
import { DfuUpdate } from '@awesome-cordova-plugins/dfu-update/ngx';
// import { FilePath } from '@awesome-cordova-plugins/file-path/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { AlertController, LoadingController, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import * as aesjs from 'aes-js';
import write_blob from "capacitor-blob-writer";
import * as CryptoJS from 'crypto-js';
import { Subject, firstValueFrom } from 'rxjs';

import { DeviceControllerService, SiteDeviceControllerService } from '../../../shared/typescript-angular-client';
import { UserService } from '../../user.service';
import { DeviceService } from '../device.service';

enum eventTypes {
  'Correct card' = 2,
  'unauthorized' = 3,
  'Ban card' = 4,
  'blacklist' = 5,
  'System code error (sector password error)' = 6,
  'unregistered' = 7,
  'Card data verification error' = 8,
  'Set successfully' = 9,
  'Setup failed' = 10,
  'Engineering Card' = 11,
  'Bluetooth unlock' = 13,
  'Get card ID' = 29,
}

enum idTypes {
  UserId,
  CardId,
  Password,
}

interface secKeys {
  regCodeStr: string,
  ivCodeStr: string,
  systemKeyStr: string
} 

@Injectable({
  providedIn: 'root',
})
export class RayoBleService extends DeviceService {
  // public deconnexion_subject: Subject<any>;

  // Device
  public device: any = { properties: {} };
  public peripheralData: any;

  // Connexion
  public isConnected: boolean = false;

  public messages: any = [];
  public rayoComKey: any;
  public rayoRandA: Uint8Array;
  public rayoIvCode: Uint8Array;
  public cmdData: any;
  public rayoKeyA: Uint8Array;
  public recvCmd: Uint8Array;

  public regCodeStr: string = 'RAYONICS87910095';
  public ivCodeStr: string = 'RAYONICSBLUELOCK';
  public systemKeyStr: string = '36363636';

  public tagId: string;
  public tagDetail: any;

  public cmdCode;

  //events
  public lastEvent: Date;
  public eventsCountRay = 0;
  public eventsList: any = [];
  public nbEvents: any = 0;

  public userInfos: any;

  public canReOpen: boolean = false;
  public authCount: number = 0;
  public isAuthenticated: boolean = false;
  // public eventsCountRayTotal: any = 0;
  public currentEventIdx: any = 0;
  public getTask: any;
  public cmd: any;

  public keyCardReverse = {};

  public serviceUUID: string;
  public txUUID: string;
  public rxUUID: string;
  public syncAfterConnect: boolean = true;
  public resetFactory: boolean;
  oldConf: any;
  sentData: any;

  // private eventTypes: Object = {
  //   "2":"Correct card",
  //   "3":"unauthorized",
  //   "4":"Ban card",
  //   "5":"blacklist",
  //   "6":"System code error (sector password error)",
  //   "7":"unregistered",
  //   "8":"Card data verification error",
  //   "9":"Set successfully",
  //   "10":"Setup failed",
  //   "11":"Engineering Card",
  //   "13":"Bluetooth unlock",
  //   "29":"Get card ID"
  // }

  constructor(
    // private ble: BLE,
    private loadCtrl: LoadingController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private platform: Platform,
    // private batteryService: BatteryService,
    // private eventService: EventService,
    // private hourService: HourService,
    // private joinLoraService: JoinloraService,
    // private openService: OpenService,
    // private paramsService: ParamsService,
    // private stockService: StockService,
    // private uniqueService: UniqueService,
    // private updateService: UpdateService,
    protected storage: Storage,
    protected deviceApi: DeviceControllerService,
    protected siteDeviceApi: SiteDeviceControllerService,
    protected userService: UserService,
    protected HTTP: HTTP,
    private dfuUpdate: DfuUpdate,
    // private filePath: FilePath,
    // private fileSystem: FileSystem
  ) {
    super(storage, deviceApi, siteDeviceApi, userService, HTTP);
    // this.deconnexion_subject = new Subject<any>();
  }

  public initDevice(device: any, bleClient: any): void {
    this.device = device;
    console.log('rayoBleService - initDevice - device:', JSON.stringify(this.device));
    this.bleClient = bleClient;
    this.resetVariables();
    this.setConfigKeys(device.properties?.config);
    this.initCmd(bleClient);
    this.initUser();
  }

  public resetVariables(): void {
    // Connexion
    this.isConnected = false;
    this.isConnecting = false;
    this.auto_connect = false;
    this.connectError = false;
    this.connexionLoader = null;
    this.mustActivate = false;

    // Action Update
    this.hasUpdate = false;
    this.updateInfos = null;
    this.isUpdating = false;
    this.percent = null;
    this.hasToUpdate = false;
    this.currentUpdate = null;
    this.checkUpdate = false;
    this.updateDispo = null;

    // Task
    this.tasksToSend = [];
    this.tasks = [];
    this.cmdFromTask = false;
    this.taskAction = null;
    this.paramIndex = null;
    this.paramsIsOk = false;
    this.taskResponse = null;
    this.currentCmdId = 0;
    this.currentTaskId = 0;
    this.mustSync = false;

    // Command
    this.sendingCmd = false;
    this.uniqueResponse = null;
    this.uniqueInput = null;
    this.cmd = null;
    this.getTask = null;

    this.bleService = null;
    this.currentAction = [];
    this.updateEnd = null;
    this.checkEventt = null;

    this.syncSubject = new Subject();
    this.connectSubject = new Subject();

    // this.loader = null;

    //Authentification
    this.isAuthenticated = false;
    this.rayoKeyA = null;
    this.rayoComKey = null;
    this.rayoIvCode = null;
    this.peripheralData = null;

    //keys
    this.regCodeStr = 'RAYONICS87910095';
    this.ivCodeStr = 'RAYONICSBLUELOCK';
    this.systemKeyStr = '36363636';

    this.keyCardReverse = {};
  }

  public initCmd(ble: any): void {
    // this.openService.setDevice(this.device, ble);
    // this.stockService.setDevice(this.device, ble);
    // this.hourService.setDevice(this.device, ble);
    // this.joinLoraService.setDevice(this.device, ble);
    // this.eventService.setDevice(this.device, ble);
    // this.paramsService.setDevice(this.device, ble);
    // this.batteryService.setDevice(this.device, ble);
    // this.updateService.setDevice(this.device, ble);
    // this.uniqueService.setDevice(this.device, ble);
  }

  // public async connectOld(syncAfterConnect: boolean = true): Promise<any> {
  //   // this.connexionService.deconnexion_subject.subscribe((res) => {
  //   //   console.log('BleService - deconnexion_subject update', res);
  //   //   this.connectSubject.next(res);
  //   // });
  //   this.syncAfterConnect = syncAfterConnect;
  //   console.log('Connecting to device:', this.device.bleId, 'syncAfterConnect:', syncAfterConnect);
  //   this.isConnecting = true;
  //   return new Promise((resolve, reject) => {
  //     const bleObserver = {
  //       next: async (peripheralData) => {
  //         // this.connected = true;
  //         this.isConnected = true;
  //         this.isConnecting = false;
  //         console.log('connected! infos:', JSON.stringify(peripheralData));
  //         this.peripheralData = peripheralData;
  //         let rayoRegex = /^(RC|RD)/g;
  //         if (!rayoRegex.exec(peripheralData.name)) {
  //           console.log('unknown device');
  //           reject(peripheralData);
  //         }
  //         if (this.platform.is('ios')) {
  //           this.serviceUUID = 'FF12';
  //           this.rxUUID = 'FF01';
  //           this.txUUID = 'FF02';
  //         } else {
  //           this.serviceUUID = '0000ff12-0000-1000-8000-00805f9b34fb';
  //           this.rxUUID = '0000ff01-0000-1000-8000-00805f9b34fb';
  //           this.txUUID = '0000ff02-0000-1000-8000-00805f9b34fb';
  //         }
  //         // this.deviceType = 'rayonics';

  //         this.bleClient
  //           .startNotifications(this.device.bleId, this.serviceUUID, this.txUUID, (data) => this.receiveRayonics(data[0]));

  //         this.rayAuthNew()
  //           .then(() => {
  //             console.log('Authentication finished');
  //             // setTimeout(() => {
  //             //   // this.rayOpen();
  //             //   const bleId = peripheralData.id;
  //             //   if (!this.isAuthenticated) {
  //             //     console.log('Not authenticated after 10s on device id:', bleId);
  //             //     if (this.device.bleId === peripheralData.id) {
  //             //       this.isConnecting = false;
  //             //       this.disconnect();
  //             //     }
  //             //   }
  //             // }, 10000);
  //           })
  //           .catch((err) => console.log('Error during authentication:', err));
  //         resolve(true);
  //       },
  //       error: async (peripheralData) => {
  //         // this.connected = false;
  //         this.isConnected = false;
  //         this.isConnecting = false;
  //         this.connectSubject.next({
  //           device: this.device,
  //           status: 'disconnected',
  //         });
  //         reject(peripheralData);
  //       },
  //       complete: () => console.log('Ble connect observer complete')
  //     }
  //     this.bleClient.connect(this.device.bleId).subscribe(bleObserver);
  //   });
  // }

  public async connect(syncAfterConnect: boolean = true): Promise<any> {
    // this.connexionService.deconnexion_subject.subscribe((res) => {
      const bleId = this.device.bleId;
      await this.bleClient.initialize();
      console.log(JSON.stringify(new Date()), 'Connecting to device:', bleId);
      if (this.platform.is('ios')) {
        this.serviceUUID = 'FF12';
        this.rxUUID = 'FF01';
        this.txUUID = 'FF02';
      } else {
        this.serviceUUID = '0000ff12-0000-1000-8000-00805f9b34fb';
        this.rxUUID = '0000ff01-0000-1000-8000-00805f9b34fb';
        this.txUUID = '0000ff02-0000-1000-8000-00805f9b34fb';
      }
      // this.deviceType = 'rayonics'
      this.isConnecting = true;
      await this.bleClient.connect(bleId);
      // this.connected = true;
      this.isConnected = true;
      // this.initBackground();
      // this.connexionTimeoutId = setTimeout(() => {
      //   console.log('connexionTimeout 60s');
      //   if (this.syncEnd) {
      //     this.disconnect();
      //   }
      // }, 60000);
      this.isConnecting = false;
      console.log('connected!');
      // this.peripheralData = peripheralData;
      // let rayoRegex = /^(RC|RD)/g;
      // if (!rayoRegex.exec(peripheralData.name)) {
      //   console.log('unknown device');
      //   return;
      // }
  
      await this.bleClient
        .startNotifications(bleId, this.serviceUUID, this.txUUID,
           (data) => {
            console.log('BT notif data:',data);
            this.receiveRayonics(data.buffer);
           }
          );
      this.rayAuthNew()
        .then(() => {
          console.log('Authentication finished');
          // setTimeout(() => {
          //   console.log('Rayonics page - bleConnect - rayAuthNew timeout');
          //   // this.rayOpen();
          //   if (!this.isAuthenticated) {
          //     this.disconnect();
          //     this.isConnecting = false;
          //   }
          // }, 10000);
        })
        .catch((err) => console.log('Error during authentication:', err));
      return true;
  }

  private setConfigKeys(config: any, factory: boolean = false) {
    if (!config) {
      console.log('RayoBleservice - SetconfigKeys => no config');
    }
    if (config.regCodeStr && config.ivCodeStr && config.systemKeyStr) {
      this.regCodeStr = config.regCodeStr;
      this.ivCodeStr = config.ivCodeStr;
      this.systemKeyStr = config.systemKeyStr;
    }
  }

  private stringToBytes(string: string) {
    var array = new Uint8Array(string.length);
    for (var i = 0, l = string.length; i < l; i++) {
      array[i] = string.charCodeAt(i);
    }
    return array.buffer;
  }

  private hexStringToBytes(hexString: string) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));
  }

  private bytesToHexString(bytes: Uint8Array) {
    return bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
  }

  // ASCII only
  private bytesToString(buffer: Uint8Array) {
    return String.fromCharCode.apply(null, new Uint8Array(buffer));
  }

  private int32ToBytes(num: number) {
    let arr = new ArrayBuffer(4); // an Int32 takes 4 bytes
    let view = new DataView(arr);
    view.setUint32(0, num, false); // byteOffset = 0; litteEndian = false
    return arr;
  }

  private int32ToBytesLE(num: number) {
    let arr = new ArrayBuffer(4); // an Int32 takes 4 bytes
    let view = new DataView(arr);
    view.setUint32(0, num, true); // byteOffset = 0; litteEndian = false
    return arr;
  }

  private int16ToBytes(num: number) {
    let buf = new ArrayBuffer(2); // an Int32 takes 4 bytes
    let view = new DataView(buf);
    view.setUint16(0, num, false); // byteOffset = 0; litteEndian = false
    return new Uint8Array(buf);
  }

  private int16ToBytesLE(num: number) {
    let buf = new ArrayBuffer(2); // an Int32 takes 4 bytes
    let view = new DataView(buf);
    view.setUint16(0, num, true); // byteOffset = 0; litteEndian = true
    return new Uint8Array(buf);
  }

  // private function xor(data1, data2) {
  private xor(data1: Uint8Array, data2: Uint8Array) {
    let res = new Uint8Array(1);
    let tmp = new Uint8Array(data1.length + data2.length);
    tmp.set(data1);
    tmp.set(data2, data1.length);
    for (let i = 0; i < tmp.length; i++) {
      if (i == 0) {
        res[0] = tmp[0] ^ tmp[1];
      } else {
        res[0] ^= tmp[i + 1];
      }
    }
    return res;
  }

  private crc16(data: Uint8Array) {
    let flag = 0;
    let wcrc = 0xffff;
    // for (let i = 0; i < data.length; i++) {
    // wcrc = wcrc ^ (data[i] & 0xff);
    for (const x of data) {
      wcrc = wcrc ^ (x & 0xff);
      for (let i = 0; i < 8; i++) {
        flag = wcrc & 0x0001;
        wcrc = wcrc >> 1;
        if (flag === 1) {
          wcrc ^= 0xa001;
        }
        wcrc = wcrc & 0xffff;
      }
    }
    return wcrc;
  }

  private getWeekOfMonth(date): Number {
    let day = date.getDate();
    day -= date.getDay() == 0 ? 6 : date.getDay() - 1; //get monday of this week
    //special case handling for 0 (sunday)

    day += 7;
    //for the first non full week the value was negative

    const prefixes = ['0', '1', '2', '3', '4', '5'];
    return Number(prefixes[0 | (day / 7)]);
  }

  private dstToBytes() {
    const start = new Date(1603587600000);
    const end = new Date(1616893200000);
    let data: Uint8Array = new Uint8Array([0xff, 0xff, 0xff, 0xff]);
    if (start.getTime() > 0) {
      // begin = Calendar.getInstance();
      // begin.setTime(beginTime);
      // const beginHex = String.format("%x%x%x%x", begin.get(Calendar.MONTH) + 1, begin.get(Calendar.WEEK_OF_MONTH),
      // begin.get(Calendar.DAY_OF_WEEK) - 1, begin.get(Calendar.HOUR)).toCharArray();
      const startMonth = (start.getMonth() + 1).toString(16);
      const startWeek = this.getWeekOfMonth(start).toString(16);
      const startDay = start.getDay().toString(16);
      const startHour = start.getHours().toString(16);
      const startHex = `${startMonth}${startWeek}${startDay}${startHour}`;
      const startBytes = this.hexStringToBytes(startHex);
      data.set(startBytes);
    }
    if (end.getTime() > 0) {
      // Calendar end = Calendar.getInstance();
      // end.setTime(endTime);
      const endMonth = (end.getMonth() + 1).toString(16);
      const endWeek = this.getWeekOfMonth(end).toString(16);
      const endDay = end.getDay().toString(16);
      const endHour = end.getHours().toString(16);
      const endHex = `${endMonth}${endWeek}${endDay}${endHour}`;
      // const endHex = HexUtil.decodeHex(String.format("%x%x%x%x", end.get(Calendar.MONTH) + 1, end.get(Calendar.WEEK_OF_MONTH),
      // end.get(Calendar.DAY_OF_WEEK) - 1, end.get(Calendar.HOUR)).toCharArray());
      const endBytes = this.hexStringToBytes(endHex);
      data.set(endBytes, 2);
    }
    return data;
  }

  private async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // private getDetail() {
  //   this.activatedRoute.queryParams.subscribe(async params => {
  //     console.log('[Params] : ', params);
  //     this.device = JSON.parse(params['device']);
  //     console.log("Device : ", this.device);
  //     this.deviceId = this.device.bleId;
  //     this.initDevice();
  //   });
  // }

  private async sendRawDataWithResp(data: Uint8Array) {
    //ajouter gestion chunks en fonction de la taille
    console.log(JSON.stringify(new Date()), 'Sending raw data:', this.buf2hex(data.buffer), 'type ', typeof data);
    // this.presentToast('Envoi en cours...');
    this.sentData = this.buf2hex(data.buffer);
    let len = data.length;
    let mtu = 20;
    if (len > mtu) {
      // await this.ble.writeWithoutResponse(this.bleId,this.serviceUUID,this.rxUUID,data.buffer)
      // .then(data => {
      //   this.presentToast('Fichier envoyé!');
      //   console.log("Raw data sent:", JSON.stringify(data));
      // }).catch(error => console.log(JSON.stringify(error)));
      let offset = 0;
      while (len > 0) {
        let chunk = data.slice(offset, offset + mtu);
        console.log('Sending chunk of size ', chunk.length, 'offset ', offset, 'remains ', len);
        await this.bleClient.write(this.device.bleId, this.serviceUUID, this.rxUUID, new DataView(chunk.buffer));
        console.log(JSON.stringify(new Date()), 'Raw data sent:', this.buf2hex(chunk.buffer));
        // .then(data => {
        //   // this.presentToast('Fichier envoyé!');
        //   console.log("Raw data sent:", JSON.stringify(data));
        // }).catch(error => console.log(JSON.stringify(error)));
        len -= chunk.length;
        offset += mtu;
      }
    } else {
      await this.bleClient
        .write(this.device.bleId, this.serviceUUID, this.rxUUID, new DataView(data.buffer))
        .then(() => {
          // this.presentToast('Trame envoyée!');
          console.log(JSON.stringify(new Date()), 'Raw data sent:', this.buf2hex(data.buffer));
        })
        .catch((error) => console.log(error));
    }
  }

  private async sendRawDataWithoutResp(data: Uint8Array) {
    //ajouter gestion chunks en fonction de la taille
    console.log(JSON.stringify(new Date()), 'Sending raw data:', this.buf2hex(data.buffer), 'type ', typeof data);
    // this.presentToast('Envoi en cours...');
    let len = data.length;
    let mtu = 20;
    if (len > mtu) {
      // await this.ble.writeWithoutResponse(this.bleId,this.serviceUUID,this.rxUUID,data.buffer)
      // .then(data => {
      //   this.presentToast('Fichier envoyé!');
      //   console.log("Raw data sent:", JSON.stringify(data));
      // }).catch(error => console.log(JSON.stringify(error)));
      let offset = 0;
      while (len > 0) {
        let chunk = data.slice(offset, offset + mtu);
        console.log('Sending chunk of size ', chunk.length, 'offset ', offset, 'remains ', len);
        await this.bleClient
          .writeWithoutResponse(this.device.bleId, this.serviceUUID, this.rxUUID, new DataView(chunk.buffer))
          .then(() => {
            // this.presentToast('Fichier envoyé!');
            console.log(JSON.stringify(new Date()), 'Raw data sent:', JSON.stringify(data.buffer));
          })
          .catch((error) => console.log(JSON.stringify(new Date()), JSON.stringify(error)));
        len -= chunk.length;
        offset += mtu;
      }
    } else {
      await this.bleClient
        .writeWithoutResponse(this.device.bleId, this.serviceUUID, this.rxUUID, new DataView(data.buffer))
        // await this.ble.write(this.bleId,this.serviceUUID,this.rxUUID,data.buffer)
        .then(() => {
          // this.presentToast('Fichier envoyé!');
          console.log(JSON.stringify(new Date()), 'Raw data sent:', JSON.stringify(data));
        })
        .catch((error) => console.log(JSON.stringify(new Date()), error));
    }
  }

  private async encryptRayonics(dataSeq: number, cmdFrame: Uint8Array) {
    console.log(
      JSON.stringify(new Date()),
      'Encrypt frame with seq:',
      dataSeq,
      ' and data:',
      this.bytesToHexString(cmdFrame),
      'regCode:',
      this.regCodeStr,
      'ivCode:',
      this.ivCodeStr
    );
    //@future -> change default system keys
    //If not yet auth, we use system keys (can be changed in the lock)
    let cbcKey = new Uint8Array(this.stringToBytes(this.regCodeStr));
    let cbcIV = new Uint8Array(this.stringToBytes(this.ivCodeStr));
    // let cbcKey = new Uint8Array(this.stringToBytes('RAYONICS87910095'));
    // let cbcIV = new Uint8Array(this.stringToBytes('RAYONICSBLUELOCK'));
    if (dataSeq === 2) {
      //Command requires valid auth/com key
      //Verify if auth key if present
      if (!this.rayoComKey || !this.rayoIvCode) {
        console.log('Not authenticated!');
        return;
      }
      cbcKey = this.rayoComKey;
      cbcIV = this.rayoIvCode;
    }
    let cryptedCmdFrame = new Uint8Array(20);
    cryptedCmdFrame[0] = dataSeq;
    console.log(
      JSON.stringify(new Date()),
      'Encrypt frame usin AES key:',
      this.bytesToHexString(cbcKey),
      'and IV:',
      this.bytesToHexString(cbcIV)
    );
    let aesCbc = new aesjs.ModeOfOperation.cbc(cbcKey, cbcIV);
    cryptedCmdFrame.set(aesCbc.encrypt(cmdFrame), 1);
    let dataCRC = this.int16ToBytesLE(this.crc16(cryptedCmdFrame.slice(0, 17)));
    cryptedCmdFrame.set(dataCRC, 17);
    console.log(
      JSON.stringify(new Date()),
      'Crypted cmd:',
      this.bytesToHexString(cryptedCmdFrame),
      'crc:',
      this.bytesToHexString(dataCRC)
    );

    return cryptedCmdFrame;
  }

  private async decryptRayonics(key: number, data: Uint8Array) {
    //@future -> change default system keys
    // console.log(JSON.stringify(new Date()), 'Decrypt frame with seq:', key, 'and data:', this.bytesToHexString(data));
    console.log(
      JSON.stringify(new Date()),
      'Decrypt frame with seq:',
      key,
      ' and data:',
      this.bytesToHexString(data),
      'regCode:',
      this.regCodeStr,
      'ivCode:',
      this.ivCodeStr
    );
    //@future -> change default system keys
    //If not yet auth, we use system keys (can be changed in the lock)
    let cbcKey = new Uint8Array(this.stringToBytes(this.regCodeStr));
    let cbcIV = new Uint8Array(this.stringToBytes(this.ivCodeStr));
    //If not yet auth, we use system keys (can be changed in the lock)
    // let cbcKey = this.rayoComKey || new Uint8Array(this.stringToBytes('RAYONICS87910095'));
    // let cbcIV = this.rayoIvCode || new Uint8Array(this.stringToBytes('RAYONICSBLUELOCK'));
    if (key === 2) {
      //Command requires valid auth/com key
      //Verify if auth key if present
      if (!this.rayoComKey || !this.rayoIvCode) {
        console.log('Not authenticated!');
        return;
      }
      cbcKey = this.rayoComKey;
      cbcIV = this.rayoIvCode;
    }
    console.log(
      JSON.stringify(new Date()),
      'Decrypting frame usin AES key:',
      this.bytesToHexString(cbcKey),
      'and IV:',
      this.bytesToHexString(cbcIV)
    );
    let aesCbc = new aesjs.ModeOfOperation.cbc(cbcKey, cbcIV);
    let decryptedCmdFrame = aesCbc.decrypt(data);
    return decryptedCmdFrame;
  }

  private checkSumRayonics(data: Uint8Array, len: number) {
    let check = 0x0;
    for (let i = 0; i < len; i++) {
      check = check ^ data[i];
    }
    return check;
  }

  private packRayonics(cmdCode: Uint8Array, cmdData: Uint8Array, len: number) {
    console.log(
      JSON.stringify(new Date()),
      'Sending cmdCode:',
      this.bytesToHexString(cmdCode),
      'cmdData:',
      this.bytesToHexString(cmdData),
      'len:',
      len
    );
    //If data > 13 bytes (maximum cmdData length), adjust the data length
    //to fit in multiple 16 bytes frames
    let data_len = 16;
    if (len > 0) {
      if (len % 13 == 0) data_len = 16 * (len / 13);
      else data_len = (Math.trunc(len / 13) + 1) * 16;
    }
    let cmdFrame = new Uint8Array(data_len);
    // memset(this->data, 0x0, data_len);

    cmdFrame[0] = len + 3;

    cmdFrame.set(cmdCode, 1);
    if (len > 0) cmdFrame.set(cmdData, 2);
    cmdFrame[len + 2] = this.checkSumRayonics(cmdFrame, len + 2);
    // this.data[len + 2] =this.xor(this.xor(cmdLen,cmdCode),cmdData);

    // return data_len;
    // console.log("packed data:", cmdFrame.buffer);
    return cmdFrame;
  }

  public async sendAndReadRayonics(
    key: number,
    cmdCode: Uint8Array,
    cmdData: Uint8Array,
    cmdDataLen: number,
    timeout: number = 10000
  ) {
    // console.log(
    //   "Send and read key:",
    //   key,
    //   "cmdCode:",
    //   cmdCode,
    //   "cmdData:",
    //   cmdData,
    //   "len:",
    //   cmdDataLen
    // );
    //Total data length: 16 bytes for cmdData < 13 bytes (1 frame), multiples of 16 bytes otherwise (32 for 2 frames, 48 for 3...)
    // const data_len = this.packRayonics(cmdCode, cmdData, cmdDataLen);
    const cmdFrame = this.packRayonics(cmdCode, cmdData, cmdDataLen);

    const max_data_len = 16;
    const ble_data_length = 20;
    const ble_frame_data_length = 19;

    //Split in mutliple frames
    let frameCount = cmdFrame.length / max_data_len;

    if (cmdFrame.length % max_data_len != 0) frameCount++;
    let send_buf = new Uint8Array(frameCount * ble_data_length);
    console.log(JSON.stringify(new Date()), 'Processing', frameCount, 'frames');
    for (let i = 0; i < frameCount; i++) {
      //For each frame, encrypt each 16 byte parts individually
      const part = cmdFrame.slice(i * max_data_len, i * max_data_len + max_data_len);
      const out_data = await this.encryptRayonics(key, part);
      this.cmdData = out_data;
      console.log(JSON.stringify(new Date()), 'Frame', i, ':', this.buf2hex(out_data.buffer));
      //Write SN: 0xFF is last frame, frame number othewise
      if (frameCount == 1 || i == frameCount - 1) {
        send_buf[i * ble_data_length] = 0xff;
      } else {
        send_buf[i * ble_data_length] = i + 1;
      }
      send_buf.set(out_data.slice(0, 19), i * ble_data_length + 1);
      console.log(JSON.stringify(new Date()), 'send_buf:', this.buf2hex(send_buf.buffer));
      // memcpy(send_buf + i * ble_data_length + 1, this->out_data, ble_frame_data_length);
    }

    return this.sendRawDataWithResp(send_buf);
  }

  public async receiveRayonics(data: any) {
    let msg = '';
    try {
      //Process ACK frames
      const hex = this.buf2hex(data.slice(1, data.length));
      msg = 'hex: ' + hex;
      msg += ', utf8:' + this.bytesToString(data);
      if (hex === 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa') {
        console.log(JSON.stringify(new Date()), 'Ack received:', this.buf2hex(data));
        return;
      }
    } catch {
      msg = 'error reading bytes';
    }
    console.log(JSON.stringify(new Date()), 'BLE Data received:', this.buf2hex(data), 'sending ACK');

    // this.messages.push(msg);
    // //this.changeRef.detectChanges();

    //cmd frame
    let dataFrame = new Uint8Array(data);

    // console.log("data:", data, "DataFrame:", dataFrame);

    //Data Serial Number (0xFF is only/last frame, ?? otherwise)
    const dataSN = dataFrame.slice(0, 1);
    //Key Sequence Number -> 0=no encryption, 1=registration code (login),
    //2 = communication key (already auth), 3= advanced key (??)
    const dataSeq = dataFrame.slice(1, 2);

    let cryptedCmdFrame = dataFrame.slice(2, dataFrame.length - 2);

    let decryptedCmdFrame = await this.decryptRayonics(dataSeq[0], cryptedCmdFrame);

    console.log(JSON.stringify(new Date()), 'Decrypted frame:', this.bytesToHexString(decryptedCmdFrame));

    if(decryptedCmdFrame[1] !== 0x27 && this.sentData && this.sentData === this.buf2hex(data)) {
      console.log(new Date(), 'Receiving same data from device, encryption error');
      this.syncSubject.next({
        device: this.device,
        status: 'connection_error',
      });
      this.isConnecting = false;
      return;
    }

    //Handle reponses with multiple frames
    if (dataSN[0] !== 0xff) {
      if (dataSN[0] === 0x01) {
        console.log(JSON.stringify(new Date()), 'Multipart frame 1');
        this.recvCmd = Uint8Array.from(decryptedCmdFrame);
      } else {
        console.log(JSON.stringify(new Date()), 'Multipart frame', dataSN[0]);
        let tmp = new Uint8Array(decryptedCmdFrame.length + this.recvCmd.length);
        tmp.set(this.recvCmd);
        tmp.set(decryptedCmdFrame, this.recvCmd.length);
        this.recvCmd = Uint8Array.from(tmp);
      }
      //Prepare ACK response
      let ackFrame = new Uint8Array(dataFrame.length);
      ackFrame[0] = dataFrame[0];
      for (let i = 1; i < ackFrame.length; i++) {
        ackFrame[i] = 0xaa;
      }
      await this.sendRawDataWithResp(ackFrame);
      return;
    }
    //0xFF => Only frame or last frame
    //if previous Data exists, concat with last data frame
    if (this.recvCmd && this.recvCmd.length > 0) {
      let tmp = new Uint8Array(decryptedCmdFrame.length + this.recvCmd.length);
      tmp.set(this.recvCmd);
      tmp.set(decryptedCmdFrame, this.recvCmd.length);
      decryptedCmdFrame = Uint8Array.from(tmp);
      this.recvCmd = new Uint8Array(0);
    }

    const cmdLen = decryptedCmdFrame.slice(0, 1);
    const cmdLenInt = cmdLen[0];

    const cmdCode = decryptedCmdFrame.slice(1, 2);
    const cmdCodeInt = cmdCode[0];

    const cmdData = decryptedCmdFrame.slice(2, cmdLen - 1);

    const cmdChecksum = decryptedCmdFrame.slice(cmdLenInt - 1, cmdLenInt);

    const cmdChecksumCalc = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    if (cmdData === this.cmdData) {
      console.log(JSON.stringify(new Date()), 'Same data error'); //When Rayonics device returns the same data that we sent, it means error
      return;
    }

    if (cmdChecksumCalc[0] !== cmdChecksum[0]) {
      console.log(JSON.stringify(new Date()), 'Cmd checksum verification failed:', cmdChecksum, decryptedCmdFrame);
      // return;
    }

    //Prepare ACK response
    let ackFrame = new Uint8Array(dataFrame.length);
    ackFrame[0] = dataFrame[0];
    for (let i = 1; i < ackFrame.length; i++) {
      ackFrame[i] = 0xaa;
    }

    console.log(
      `cmdLen:${cmdLen},cmdCode:${this.bytesToHexString(cmdCode)},cmdData:${this.bytesToHexString(
        cmdData
      )},cmdChecksum:${this.bytesToHexString(cmdChecksum)}`
    );

    //Process response depening on command code
    switch (cmdCode[0]) {
      //Authentication response
      case 0x0f:
        await this.sendRawDataWithResp(ackFrame);
        // console.log("Gen rayonics password");
        await this.genRayoPwd(cmdData);
        this.isAuthenticated = true;
        // this.presentToast('Authentification réussie');
        //Wait 500ms for the lock to generate AES keys
        await this.delay(500);
        this.cmd = 'hour';
        //this.changeRef.detectChanges();
        const res = await this.mustChangeKeys();
        if(res) {
          console.log('Keys changed, wait for changeKeys response');
          await this.rayChangeKeys();
          break;
        } else {
          console.log('Keys not changed, set device time');
          await this.raySetLockTime();
          console.log("Device time set command sent");
        }
        break;
      //Lock information response
      case 0x0e:
        console.log('Received lock info');
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 1 && cmdData[0] === 0x01) {
          console.log('Read Lock info failure');
          break;
        }
        this.readLockInfo(cmdData);
        //Start events sync
        // this.rayGetEventsCount();
        this.updateLastSync();
        this.syncSubject.next({ device: this.device, status: 'end' });
        // this.syncEnd = true;
        // this.stopInput = false;
        // this.doRefresh();
        // if (!this.changeRef['destroyed']) {
        //this.changeRef.detectChanges();
        // }

        //Else, process authentication sucess with 0x0D code
        break;
      //Authentication response (for compatibility with old locks)
      case 0x0d:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 1 && cmdData[0] === 0x01) {
          console.log('Authentication failed');
          console.log('Erreur de connexion, veuillez réessayer');
          // this.syncEnd = true;
          // this.stopInput = false;
          this.updateLastSync();
          this.syncSubject.next({
            device: this.device,
            status: 'connection_error',
          });
          this.isConnecting = false;
          // console.log("Authentication failure, try", this.authCount, "on 3");
          // if (this.authCount <= 3) {
          //   this.rayReconnect();
          // }
          // console.log("Max authentication attempts reach, abort");
          break;
        } else {
          //Else, process authentication sucess with 0x0D code
          // await this.sendRawDataWithResp(ackFrame);
          console.log("Gen rayonics password without PK");
          await this.genRayoPwd(cmdData, false);
          this.isAuthenticated = true;
          //this.presentToast('Authentification réussie');
          await this.delay(500);
          const res = await this.mustChangeKeys();
          if(res) {
            await this.rayChangeKeys();
            console.log('Keys changed, wait for changeKeys response');
            break;
          } else {
            console.log('Keys not changed, set device time');
            await this.raySetLockTime();
            console.log("Device time set command sent");
          }
        }
        break;
      //Lock status chahnged event
      case 0x0c:
        console.log('Recevied status changed frame');
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length !== 10) {
          console.log('Authentication failure');
          break;
        }
        await this.rayReadStatusFrame(cmdData);
        //Else, process authentication sucess with 0x0D code
        break;
      //Read keycard response
      case 0x29:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData[0] === 0x00) {
          console.log('Read keyCard success');
          //this.presentToast('Lecture badge réussie');
        } else {
          console.log('Unknown read keycard failure');
          //this.presentToast('Erreurlecture badge: erreur inconnue');
        }
        break;
      //Read reset response
      case 0x27:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 6) {
          const errs = cmdData.filter((b) => b !== 0x00 && b != 0x01);
          if (errs.length > 0) {
            console.log('Some registers were not cleared');
            //this.presentToast(
            //   "Erreur lors de la réinitialisation du cylindre: certains registres n'ont pas pu être supprimés. Veuillez réessayer"
            // );
          } else {
            console.log('Reset lock success');
            //this.presentToast('Réinitialisation du cylindre réussie');
            if (this.cmdFromTask) {
              this.taskAction = 'reset';
              this.validateTask();
              //after device reset confirmed, set back keys to factory
              // await this.delay(500);
              // await this.rayChangeKeys(true);
            }
          }
        } else {
          console.log('Unknown reset failure');
          //this.presentToast(
          //   'Erreur lors de la réinitialisation du cylindre. Veuillez réessayer'
          // );
        }
        break;
      case 0x22:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 1 && (cmdData[0] === 0x00 || cmdData[0] === 0x03)) {
          console.log('Set permission success');
          //this.presentToast('Permission modifiée avec succès');
          //If we're waiting for a task/command response, confirm this command
          if (this.cmdFromTask) {
            this.paramsIsOk = true;
            this.taskAction = 'params';
            this.validateTask();
          }
        } else {
          console.log(`Unknown set permission failure: cmdLen: ${cmdData.length}
            ,cmdData: ${this.bytesToHexString(cmdData)}`);
          //this.presentToast(`Erreur modification permission`);
          //If we're waiting for a task/command response, do nothing
          //and proceed with next command
          if (this.cmdFromTask) {
            this.cmdFromTask = false;
            this.syncTasks();
          }
        }
        break;
      //Query permission response
      case 0x21:
        await this.sendRawDataWithResp(ackFrame);
        if (this.cmdCode === 0x21 && cmdData.length > 16) {
          console.log('Query permission success');
          // this.rayReadQueryPermission(cmdData);
          break;
        }
        //Else Display error msg
        if (cmdData.length === 1 && cmdData[0] === 0x01) {
          console.log('Query permission : command failed');
          //this.presentToast('Erreur requête permission: echec de la commande');
        } else if (cmdData.length === 1 && cmdData[0] === 0x02) {
          console.log('Query permission: not available');
          //this.presentToast(
          //   'Erreur requête permission: commande non disponible'
          // );
        } else {
          console.log('Unknown set permission failure');
          //this.presentToast('Erreur modification permission: erreur inconnue');
        }
        break;
      //Open response
      case 0x20:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData[0] === 0x00) {
          console.log('Open sucess');
          //this.presentToast('Activation réussie');
          // await this.delay(8000);
          // this.canReOpen = true;
        } else if (cmdData[0] === 0x01) {
          console.log('Open failure');
          //this.presentToast("Erreur lors de l'ouverture");
        }
        break;
      //Clear events response
      case 0x1b:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 1 && cmdData[0] === 0x00) {
          console.log('Clear events sucess');
          //this.presentToast('Evénements supprimés avec succès');
        } else {
          console.log('Clear events error');
          //this.presentToast('Erreur lors de la suppression des événements');
        }
        //Else, process authentication sucess with 0x0D code
        break;
      case 0x1a:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 1 && cmdData[0] === 0x01) {
          console.log('Get event failure');
          //this.presentToast('Erreur récupération événement');
        } else {
          console.log('Get event success');
          //this.presentToast(
          //   `Evénement ${this.currentEventIdx}/${this.eventsCountRay} reçu`
          // );
          console.log(cmdData);
          this.readEventFrame(cmdData);
        }
        if (this.currentEventIdx < this.eventsCountRay) {
          this.currentEventIdx++;
          this.rayGetEvent(this.currentEventIdx);
        } else {
          this.updateLastSync();
          this.sendEventsToApi();
        }
        break;
      //Get events count response
      case 0x19:
        await this.sendRawDataWithResp(ackFrame);
        if ((cmdData.length === 1 && cmdData[0] === 0x01) || cmdData.length !== 6) {
          console.log('Get event count failure');
          //this.presentToast('Erreur récupération nombre événements');
        } else {
          console.log(cmdData);
          this.readEventsCountFrame(cmdData);
          if (this.eventsCountRay > 0) {
            this.currentEventIdx = 1;
            this.rayGetEvent(this.currentEventIdx);
            // //Loop on each event
            // for (let i = 0; i < count; i++) {
            //   await this.delay(50);
            //   this.rayGetEvent(i + 1);
            // }
          } else {
            this.updateLastSync();
            //this.syncEnd = true;
            this.syncSubject.next({ device: this.device, status: 'end' });
            // this.stopInput = false;
            // this.doRefresh();
            // if (!this.changeRef['destroyed']) {
            //this.changeRef.detectChanges();
            // }
          }
        }
        break;
      case 0x18:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData[0] === 0x01) {
          console.log('Get status failure');
          //this.presentToast('Erreur récupération statut');
        } else {
          console.log(cmdData);
        }
        break;
      //Set lock time response
      case 0x11:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData[0] === 0x00) {
          console.log(cmdData, 'syncAfterConnect:', this.syncAfterConnect);
          if (!this.syncAfterConnect) {
            this.syncSubject.next({
              device: this.device,
              status: 'end',
            });
            break;
          }
          //this.presentToast("Mise à l'heure réussie");
          this.deviceApi.GetDeviceTask(this.device.id).subscribe(async (res) => {
            // this.getTask = false;
            console.log('API Tasks : ', res);
            this.tasks = res;

            this.syncTasks();
          });
        } else {
          console.log('Set time failure');
          //this.presentToast("Erreur mise à l'heure");
          this.syncSubject.next({
            device: this.device,
            status: 'timesync_error',
          });
        }
        break;
      //Set lock information response
      case 0x12:
        console.log('Received set lock info response');
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData.length === 1 && cmdData[0] === 0x01) {
          console.log('Set Lock info failure');
          break;
        }
        console.log('Set lock info success');
        // this.readLockInfo(cmdData);
        // this.updateLastSync();
        // this.syncSubject.next({ device: this.device, status: 'end' });
        //Else, process authentication sucess with 0x0D code
        break;
      //Change keys response
      case 0x10:
        await this.sendRawDataWithResp(ackFrame);
        if (cmdData[0] === 0x00) {
          console.log('Change keys sucess');
          // this.presentToast('Changement clés réussi');
          //Re-auth to regenerate comKey/ivCode with new keys from device's config
          this.rayAuthNew()
            .then(async () => {
              console.log('Authentication finished');
              this.syncSubject.next({
                device: this.device,
                status: 'keys_end',
              });
              await this.delay(500);
              this.raySetLockTime();
              // setTimeout(() => {
              //   // this.rayOpen();
              //   if (!this.isAuthenticated) {
              //     this.disconnect();
              //     this.isConnecting = false;
              //   }
              // }, 10000);
            })
            .catch((err) => {
              console.log('Error during authentication:', err);
              this.syncSubject.next({
                device: this.device,
                status: 'keys_error',
              });
            });
        } else {
          console.log('Change keys failure');
          this.syncSubject.next({
            device: this.device,
            status: 'keys_error',
          });
          console.log('Rayonics service - receiveRayonics 0x10 - Change keys failure, rolling back...');
          this.setConfigKeys(this.oldConf);
          await firstValueFrom(this.deviceApi.updateDevice(this.device.id, { value: this.oldConf }, 'config'));
          // this.presentToast('Erreur changement clés');
          //Reset config to factory keys??
        }
        break;
      default:
        console.log('Unknown cmd code');
        await this.sendRawDataWithResp(ackFrame);
        if (!this.isAuthenticated) {
          console.log('Not authenticated, disconnect device');
          //this.syncEnd = true;
          this.syncSubject.next({
            device: this.device,
            status: 'connection_error',
          });
          // this.stopInput = false;
          this.isConnecting = false;
          // this.doRefresh();
          // this.bleDisconnect();
          this.disconnect();
          // console.log("Reconnexion en cours");
          // console.log("Authentication failure, try", this.authCount, "on 3");
          // if (this.authCount <= 3) {
          //   this.bleDisconnect();
          //   await this.delay(1000);
          //   this.bleConnect();
          // }
          // console.log("Max authentication attempts reach, abort");
        }
        break;
    }

    let dataCRC = dataFrame.slice(dataFrame.length - 2, dataFrame.length);
    console.log('SN:', dataSN, 'Seq:', dataSeq, 'cmdFrame:', decryptedCmdFrame, 'CRC:', dataCRC);
  }

  public rayReadStatusFrame(data: Uint8Array) {
    // const buf = new ArrayBuffer(10);
    // const arr = new Uint8Array(buf);
    // arr.set(data);
    const buf = data.buffer;
    const dv = new DataView(buf, 0);
    const curTime = dv.getUint32(0, true);
    const curDate = new Date(curTime * 1000);

    const eventType = data[4];
    const status = data[5]; // @future read bit by bit
    const cardId = this.bytesToHexString(data.slice(6, 10));
    const msg = `date: ${curDate},type:${eventType},statut:${status},n° badge:${cardId}`;
    this.messages.push(msg);
    this.tagId = cardId;
  }

  public readLockInfo(data: Uint8Array) {
    // const buf = new ArrayBuffer(10);
    // const arr = new Uint8Array(buf);
    // arr.set(data);
    console.log('Read lock info:', this.bytesToHexString(data));
    const buf = data.buffer;
    const dv = new DataView(buf, 0);

    const mac = this.bytesToHexString(data.slice(0, 6).reverse());
    const hwVersion = this.bytesToString(data.slice(6, 16));
    const swVersion = this.bytesToString(data.slice(16, 26));
    const factoryTime = dv.getInt32(26, true);
    const factoryDate = new Date(factoryTime * 1000);
    const deviceTime = dv.getInt32(30, true);
    console.log(factoryTime, deviceTime);
    const deviceDate = new Date(deviceTime * 1000);
    const lockId = data.slice(34, 38);
    const building = data.slice(38, 41);
    const lockType = data[41];
    const roomType = data[42];
    const lockReversalTime = data[43];
    const permissionMethod = data[44];
    const lockDisableFlag = data[45];
    const btBroadcastMode = data[46];
    const connectHsInfo = data[47];
    const officeMode = data[48];
    const cylinderId = data.slice(49, 51);
    const battery = data[51];
    const autoCleanPerm = data[52];
    const autoCleanBlacklist = data[53];
    const tzHours = data[54];
    const dst = data[55];
    const buzzer = data[56];
    const light = data[57];
    const tamper = data[57];
    const tempPwd = data[58];
    const tzMinutes = data[59];
    //@future => ajout infos derniers firmwares

    const msg = `mac: ${mac},hwVersion: ${hwVersion},swVersion: ${swVersion},
      factoryTime: ${factoryDate},deviceTime:${deviceDate},battery:${battery}%,
      tz:${tzHours}:${tzMinutes}`;
    //  this.messages.push(msg);

    const body = [
      {
        properties: {
          payload: {
            type: 'battery',
            battery: battery,
          },
        },
      },
    ];

    console.log('BatteryBody: ', body);

    this.device.properties.battery = battery;

    this.syncSubject.next({
      device: this.device,
      status: 'battery_update',
    });

    this.deviceApi
      .siteDeviceBattery(this.device.id, body)
      .toPromise()
      .then(
        (res) => {
          console.log('Battery : ', res);
        },
        (error) => {
          console.log('Battery : ', error);
        }
      );

    let deviceConfig = this.device.properties.config;
    deviceConfig.mainFwVersion = swVersion;
    deviceConfig.rfidFwVersion = hwVersion;
    deviceConfig.unlockDuration = lockReversalTime;
    deviceConfig.btBroadcastMode = btBroadcastMode;
    deviceConfig.autoCleanPerm = autoCleanPerm;
    deviceConfig.cylinderId = cylinderId;
    deviceConfig.lockId = lockId;
    deviceConfig.connectHsInfo = connectHsInfo;
    deviceConfig.buzzer = buzzer;
    deviceConfig.light = light;
    deviceConfig.deviceDate = deviceDate;
    // this.device.properties.config = deviceConfig;
    // this.deviceApi.updateDevice(this.device.id, { value: deviceConfig }, 'config').subscribe((res) => {
    //   console.log('Update SW version end : ', res);
    // });
    this.deviceApi.updateDevice(this.device.id, { value: swVersion }, 'config.mainFwVersion').subscribe((res) => {
      console.log('Update SW version end : ', res);
    });

    this.deviceApi.updateDevice(this.device.id, { value: hwVersion }, 'config.rfidFwVersion').subscribe((res) => {
      console.log('Update HW version end : ', res);
    });

    this.deviceApi.updateDevice(this.device.id, { value: lockReversalTime }, 'config.unlockDuration').subscribe((res) => {
      console.log('Update unlock duration end : ', res);
    });

    this.deviceApi.updateDevice(this.device.id, { value: btBroadcastMode }, 'config.btBroadcastMode').subscribe((res) => {
      console.log('Update btBroadcastMode end : ', res);
    });

    // this.deviceApi.updateDevice(this.device.id, { value: autoCleanPerm }, 'config.autoCleanPerm').subscribe((res) => {
    //   console.log('Update autoCleanPerm end : ', res);
    // });

    // this.deviceApi.updateDevice(this.device.id, { value: cylinderId }, 'config.cylinderId').subscribe((res) => {
    //   console.log('Update cylinderId end : ', res);
    // });

    // this.deviceApi.updateDevice(this.device.id, { value: lockId }, 'config.lockId').subscribe((res) => {
    //   console.log('Update lockId end : ', res);
    // });

    // this.deviceApi.updateDevice(this.device.id, { value: connectHsInfo }, 'config.connectHsInfo').subscribe((res) => {
    //   console.log('Update connectHsInfo end : ', res);
    // });

    // this.deviceApi.updateDevice(this.device.id, { value: buzzer }, 'config.buzzer').subscribe((res) => {
    //   console.log('Update buzzer end : ', res);
    // });

    // this.deviceApi.updateDevice(this.device.id, { value: light }, 'config.light').subscribe((res) => {
    //   console.log('Update light end : ', res);
    // });

    // this.deviceApi.updateDevice(this.device.id, { value: deviceDate }, 'config.deviceDate').subscribe((res) => {
    //   console.log('Update deviceDate end : ', res);
    // });


  }

  public readEventsCountFrame(data: Uint8Array) {
    console.log('start readEventsCountFrame');
    const buf = data.buffer;
    const dv = new DataView(buf, 0);

    // arr.set(data);
    const count = new Uint16Array(data.slice(0, 2))[0];
    this.eventsCountRay = count;
    const lastEventTs = dv.getUint32(2, true);
    const lastEventDate = new Date(lastEventTs * 1000);

    const msg = `count: ${count},lastTs:${lastEventDate}`;
    this.messages.push(msg);
    if (this.lastEvent && this.lastEvent > lastEventDate) {
      console.log('Last cylinder event older than last database event, no sync needed');
    }

    console.log('readEventsCountFrame : ', msg);
  }

  public readEventFrame(data: Uint8Array) {
    console.log('start readEventFrame');
    const buf = data.buffer;
    const dv = new DataView(buf, 0);

    // const arr = new Uint8Array(buf);
    // arr.set(data);
    const idType = idTypes[Number(data[0])]; //1=UserId, 2=CardID, 3=Password
    const id = this.bytesToHexString(data.slice(1, 7));
    const eventTypeId = data[7];
    const eventType = eventTypes[eventTypeId];
    const eventTs = dv.getInt32(8, true);
    const eventDate = new Date(eventTs * 1000);

    const msg = `Evénement: type: ${eventType},ts:${eventTs} date: ${eventDate.toISOString()},support: ${idType},id:${id}`;

    console.log('eadEventFrame data : ', data);
    console.log('readEventFrame eventTypeId : ', eventTypeId);
    var body = {
      // userId: this.userInfos.id,
      deviceId: this.device.id,
      siteId: this.device.siteId,
      accessId: 0,
      properties: {
        type: null,
        level: null,
        payload: null,
        creationDate: eventDate,
      },
    };

    let error = false;

    switch (eventTypeId) {
      // type "Correct Card"
      case 2:
        body.properties.type = 'deviceController.accessgranted';
        body.properties.payload = { keyCardNumber: id }; //id = variable id dans readEventFrame
        body.properties.level = 'info';
        break;
      // "unauthorized"
      case 3:
        body.properties.type = 'deviceController.accessrefused';
        body.properties.payload = { keyCardNumber: id };
        body.properties.level = 'alert';
        break;
      //"Ban card"
      case 4:
        // body.properties.type = "deviceController.banned";
        body.properties.type = 'deviceController.accessrefused';
        body.properties.payload = { keyCardNumber: id };
        body.properties.level = 'alert';
        break;
      // "Blacklist"
      case 5:
        // body.properties.type = "deviceController.blacklisted";
        body.properties.type = 'deviceController.accessrefused';
        body.properties.payload = { keyCardNumber: id };
        body.properties.level = 'alert';
        break;
      //"System code error (sector password error)"
      case 6:
        console.log('System code error (sector password error)');
        // body.properties.type = "deviceController.";
        // body.properties.payload = {};
        // body.properties.level = "alert";
        break;
      //"unregistered"
      case 7:
        // body.properties.type = "deviceController.unregistered";
        body.properties.type = 'deviceController.accessrefused';
        body.properties.payload = { keyCardNumber: id };
        body.properties.level = 'alert';
        break;
      //"Card data verification error"
      case 8:
        console.log('Card data verification error');
        // body.properties.type = "deviceController.";
        // body.properties.payload = {};
        // body.properties.level = "alert";
        break;
      //"Set successfully"
      case 9:
        console.log('Set successfully');
        // body.properties.type = "deviceController.";
        // body.properties.payload = {};
        // body.properties.level = "alert";
        break;
      //"Setup failed"
      case 10:
        console.log('Set successfully');
        // body.properties.type = "deviceController.";
        // body.properties.payload = {};
        // body.properties.level = "alert";
        break;
      //"Engineering Card"
      case 11:
        console.log('Set successfully');
        // body.properties.type = "deviceController.admingranted";
        body.properties.type = 'deviceController.accessgranted';
        body.properties.payload = { keyCardNumber: id }; //id = variable id dans readEventFrame
        body.properties.level = 'info';
        break;
      // "Bluetooth unlock"
      case 13:
        body.properties.type = 'deviceController.door_open';
        body.properties.payload = {};
        body.properties.level = 'info';
        break;
      // "Get Card ID"
      case 29:
        console.log('Get Card Id');
        // body.properties.type = "deviceController.";
        // body.properties.payload = {};
        // body.properties.level = "alert";
        break;
      default:
        error = true;
        console.log('Unknown type id');
        break;
    }

    if (!error) this.eventsList.push(body);

    console.log(
      'ReadEventFrame (eventsList.Length, eventsCount) : ',
      this.eventsList.length + ', ',
      this.eventsCountRay
    );

    // if (!this.changeRef['destroyed']) {
    //this.changeRef.detectChanges();
    // }
  }

  public async genRayoPwd(data: Uint8Array, usePk = true) {
    const keyB = data.slice(0, 10);
    const crc = data.slice(10, 12);
    console.log('randB:', keyB, 'crc:', crc);
    const calcCrc = this.int16ToBytesLE(this.crc16(keyB));
    if (calcCrc[0] != crc[0] || calcCrc[1] != crc[1]) {
      console.log('CRC error in 0xF response', crc, calcCrc);
      return;
    }
    // const regCodeStr = 'RAYONICS87910095';
    const regCode = new Uint8Array(this.stringToBytes(this.regCodeStr));
    const userId = this.hexStringToBytes('123456123456');
    const systemKey = this.hexStringToBytes(this.systemKeyStr);
    // const systemKey = this.hexStringToBytes('36363636');

    // let uidRandA = new Uint8Array(this.rayoRandA.length + userId.length);
    // uidRandA.set(userId);
    // uidRandA.set(this.rayoRandA,userId.length);

    let keyA = this.rayoKeyA;

    let xorAB = new Uint8Array(keyA.length);

    for (let i = 0; i < xorAB.length; i++) {
      xorAB[i] = keyA[i] ^ keyB[i];
    }

    // const crc = this.buf2hex(this.crc16(crcArr));
    //(User ID + randomization A) and random byte XOR B (10bytes) + system key ( . 4 bytes) + the CRC . 1 . 6 check (2bytes)
    let salt = new Uint8Array(keyA.length + systemKey.length + 2);
    salt.set(xorAB);
    salt.set(systemKey, 10);
    const crcArr = this.int16ToBytesLE(this.crc16(salt.slice(0, 14))); //crc sur keyB ou xorAB??
    salt.set(crcArr, 14);
    if (!usePk) {
      this.rayoComKey = salt;
      // this.rayoIvCode = new Uint8Array(this.stringToBytes('RAYONICSBLUELOCK'));
      this.rayoIvCode = new Uint8Array(this.stringToBytes(this.ivCodeStr));
    } else {
      try {
        const dk = await this.genPbkdf2(this.regCodeStr, this.bytesToHexString(salt));
        console.log(dk);
        const trancKeyCode = dk.slice(0, 16);
        const ivCode = dk.slice(16, 32);
        this.rayoComKey = trancKeyCode;
        this.rayoIvCode = ivCode;
      } catch (err) {
        console.log(err);
      }
    }
    console.log(`UserId:${this.bytesToHexString(userId)},
    RandA:${this.bytesToHexString(this.rayoKeyA)},
    RandB:${this.bytesToHexString(keyB)},
    SystemCode:${this.bytesToHexString(systemKey)},
    RegisterCode:${this.bytesToHexString(regCode)},
    Salt:${this.bytesToHexString(salt)},
    Comkey:${this.bytesToHexString(this.rayoComKey)},
    ivCode:${this.bytesToHexString(this.rayoIvCode)}`);
    return;
    // const derivedKey = pbkdf2.pbkdf2Sync(regCode, salt, 250, 384);
  }

  public async genPbkdf2(regCode: string, salt: string): Promise<Uint8Array> {
    const key = CryptoJS.algo.PBKDF2.create({
      keySize: 384 / 32,
      hasher: CryptoJS.algo.SHA256,
      iterations: 250,
    }).compute(regCode, CryptoJS.enc.Hex.parse(salt));
    const hex = CryptoJS.enc.Hex.stringify(key);
    return new Uint8Array(this.hexStringToBytes(hex));
  }

  public async genPbkdf2String(regCode: string, salt: string): Promise<string> {
    const key = CryptoJS.algo.PBKDF2.create({
      keySize: 384 / 32,
      hasher: CryptoJS.algo.SHA256,
      iterations: 250,
    }).compute(regCode, CryptoJS.enc.Hex.parse(salt));
    const hex = CryptoJS.enc.Hex.stringify(key);
    return hex;
  }

  public async genDeviceKeys(): Promise<secKeys> {
    const salt = 'Inoveo@7ruedesaulnes@2024';
    const key = await this.genPbkdf2String(this.device.serialNumber,salt);
    return {
      ivCodeStr: key.slice(0,16),
      regCodeStr: key.slice(16,32),
      systemKeyStr: key.slice(32,40)
    }
  }

  public randomString(length: any): string {
    let result = '';
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  public randomHexString(length: any): string {
    let result = '';
    const chars = '0123456789ABCDEF';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  public async rayReconnect(): Promise<void> {
    // this.bleDisconnect();
    this.disconnect();
    await this.delay(1000);
    // this.bleConnect();
    this.connect();
  }

  public async rayAuthNew(): Promise<void> {
    let dataSeq = 1;

    //cmd frame
    let cmdFrame = new Uint8Array(16);

    let cmdCode = new Uint8Array([0x0d]);
    let userId = new Uint8Array([0x12, 0x34, 0x56, 0x12, 0x34, 0x56]);
    // let userId = new Uint8Array([0x00,0x00,0x00,0x00,0x00,0x01]);
    let randA = new Uint8Array(10);
    window.crypto.getRandomValues(randA);
    let cmdCRCArr = new Uint8Array(10);
    cmdCRCArr.set(randA);
    //overwrite first 6 bytes of random A with userID
    cmdCRCArr.set(userId);
    let cmdCRC = this.int16ToBytesLE(this.crc16(cmdCRCArr));
    console.log(cmdCRC);
    let cmdData = new Uint8Array(12);
    cmdData.set(cmdCRCArr);
    cmdData.set(cmdCRC, 10);

    this.rayoKeyA = cmdCRCArr;
    this.cmdData = cmdData;

    await this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async mustChangeKeys(): Promise<boolean> {
    const locked = this.device.properties?.config?.keysLocked;
    //If factory used and we are not resetting to factory, change it for new unique keys
    if(!this.resetFactory && !locked
      && this.regCodeStr === 'RAYONICS87910095'
      && this.ivCodeStr === 'RAYONICSBLUELOCK'
      && this.systemKeyStr === '36363636'
    ) {
      console.log('Factory keys used, generating news keys');
      return true;
    }
    console.log('Keys different from factory or locked, change not needed');
    return false;
  }

  public async rayChangeKeys(factory = false,newKeys: secKeys | undefined = undefined): Promise<void> {
    let dataSeq = 2;

    let cmdCode = new Uint8Array([0x10]);
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);

    console.log('Current keys:', this.regCodeStr, this.ivCodeStr, this.systemKeyStr);

    const config = await this.device.properties.config;
    this.oldConf = structuredClone(config);
    if (factory) {
      this.resetFactory = true;
      config.regCodeStr = 'RAYONICS87910095';
      config.ivCodeStr = 'RAYONICSBLUELOCK';
      config.systemKeyStr = '36363636';
    } else if(newKeys) {
      config.regCodeStr = newKeys.regCodeStr;
      config.ivCodeStr = newKeys.ivCodeStr;
      config.systemKeyStr = newKeys.systemKeyStr;
    }  else {
      const keys = await this.genDeviceKeys();
      config.regCodeStr = keys.regCodeStr;
      config.ivCodeStr =  keys.ivCodeStr;
      config.systemKeyStr = keys.systemKeyStr;
      // config.regCodeStr = this.randomString(16);
      // config.ivCodeStr = this.randomString(16);
      // config.systemKeyStr = this.randomHexString(8);
    }

    if(!this.isConnected) {
      console.log('Rayonics page - rayChangeKeys - not connected, aborting');
      return;
    }
    //update str variables
    // this.regCodeStr = config.regCodeStr;
    // this.ivCodeStr = config.ivCodeStr;
    // this.systemKeyStr = config.systemKeyStr;
    this.setConfigKeys(config);
    //regCodeStr = 'RAYONICS87910095';
    const regCode = new Uint8Array(this.stringToBytes(config.regCodeStr));
    // const userId = this.hexStringToBytes('123456123456');
    //rayoIvCode = new Uint8Array(this.stringToBytes('RAYONICSBLUELOCK'));
    const ivCode = new Uint8Array(this.stringToBytes(config.ivCodeStr));
    //systemKey = this.hexStringToBytes('36363636');
    const systemKey = this.hexStringToBytes(config.systemKeyStr);
    //Save new keys in config (local storage + API). If anything goes wrong, abort
    try {
      // await this.deviceApi.updateDevice(this.device.id, { value: config }, 'config').toPromise();
      await firstValueFrom(this.deviceApi.updateDevice(this.device.id, { value: config }, 'config'));
      console.log('Rayonics page - rayChangekeys - api update ok');
    } catch(e) {
      console.log('Rayonics page - rayChangeKeys - error while updating news keys in device config api:',e);
      this.setConfigKeys(this.oldConf);
      return;
    }
    //update local storage
    //storage.save(....)
    // this.rayoIvCode = ivCode;
    //don't update this.rayoIvCode, this.trancKey etc before sending 0x10 command

    console.log('Generated and saved new keys:', this.regCodeStr, this.ivCodeStr, this.systemKeyStr);

    let cmdData = new Uint8Array(36);
    cmdData.set(regCode);
    cmdData.set(ivCode, 16);
    cmdData.set(systemKey, 32);

    console.log('cmdData', cmdData);

    let cmdLen = new Uint8Array([cmdData.length + 3]); //3 bytes for len, cmd word + checksum
    let cmdChecksum = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    console.log('New keys Cmd:', dataSeq, cmdCode, cmdData);

    if(!this.isConnected) {
      console.log('Rayonics page - rayChangeKeys - not connected after updating api, rolling back...');
      this.setConfigKeys(this.oldConf);
      await firstValueFrom(this.deviceApi.updateDevice(this.device.id, { value: this.oldConf }, 'config'));
      return;
    }

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public rayOpen(): Promise<void> {
    let dataSeq = 2;

    let cmdCode = new Uint8Array([0x20]);
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);
    const now = Math.floor(new Date().getTime() / 1000);
    const startTime = new Uint8Array(this.int32ToBytesLE(now - 60));
    const endTime = new Uint8Array(this.int32ToBytesLE(now + 60));

    let cmdData = new Uint8Array(8);
    cmdData.set(startTime);
    cmdData.set(endTime, 4);
    let cmdLen = new Uint8Array([cmdData.length + 3]); //3 bytes for len, cmd word + checksum
    let cmdChecksum = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public raySetLockTime(): Promise<void> {
    console.log('Setting lock time');
    let dataSeq = 2;

    let cmdCode = new Uint8Array([0x11]);
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);
    const now = Math.ceil(new Date().getTime() / 1000);
    const time = new Uint8Array(this.int32ToBytesLE(now));
    // if (window.Intl && typeof window.Intl === 'object') {
    //   console.log('API available');
    // }
    const tzHours = new Uint8Array([0x01]);
    const tzMinutes = new Uint8Array([0x00]);
    const dst = this.dstToBytes();

    let cmdData = new Uint8Array(10);
    cmdData.set(time);
    cmdData.set(tzHours, 4);
    cmdData.set(dst, 5);
    cmdData.set(tzMinutes, 9);
    let cmdLen = new Uint8Array([cmdData.length + 3]); //3 bytes for len, cmd word + checksum
    let cmdChecksum = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }
  public rayResetLock(): Promise<void> {
    console.log('Reset lock');
    let dataSeq = 2;

    let cmdCode = new Uint8Array([0x27]);
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);
    const clearBasicInfo = new Uint8Array([0x01]); //0x01 = clear, 0x02 = dont clear
    const clearOfficeMode = new Uint8Array([0x01]); //0x01 = clear, 0x02 = dont clear
    const clearPermissions = new Uint8Array([0x01]); //0x01 = clear, 0x02 = dont clear
    const clearEvents = new Uint8Array([0x01]); //0x01 = clear, 0x02 = dont clear
    const clearBlacklist = new Uint8Array([0x01]); //0x01 = clear, 0x02 = dont clear
    const clearHotspotInfo = new Uint8Array([0x01]); //0x01 = clear, 0x02 = dont clear

    let cmdData = new Uint8Array(6);
    cmdData.set(clearBasicInfo);
    cmdData.set(clearOfficeMode, 1);
    cmdData.set(clearPermissions, 2);
    cmdData.set(clearEvents, 3);
    cmdData.set(clearBlacklist, 4);
    cmdData.set(clearHotspotInfo, 5);

    let cmdLen = new Uint8Array([cmdData.length + 3]); //3 bytes for len, cmd word + checksum
    let cmdChecksum = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public raySetOfficeMode(
    mode: number,
    timeSlices: {
      officeModeType: number;
      days: number;
      // startTime: number;
      // endTime: number;
    }[]
  ): Promise<void> {
    console.log('Setting office mode');
    let dataSeq = 2;

    //mode 1 = normal mode, 2 = office mode
    let cmdCode = new Uint8Array([0x14]);

    const officeMode = new Uint8Array([mode]);

    const tSliceCount = new Uint8Array([timeSlices.length]);

    console.log('Officemode:', officeMode, 'tSliceCount:', tSliceCount);

    let tSlices = new Uint8Array(5 * timeSlices.length);
    for (let i = 0; i < timeSlices.length; i++) {
      let tSlice = new Uint8Array(5);
      //Office modes: 1 = time slice mode, 2 = switch mode, 3 = time slice switch mode
      // const officeModeType = new Uint8Array([1]);
      const officeModeType = new Uint8Array([timeSlices[i].officeModeType || 1]);
      //Days of week coded on 1 bytes (1 bit per day starting sunday)
      // const daysOfWeek = 0xff; //@future -> parse days object
      const daysOfWeek = timeSlices[i].days || 0xff; //@future -> parse days object
      const week = new Uint8Array([daysOfWeek]);
      let time = new Uint8Array(3);
      time.set(new Uint8Array([0x00]));
      time.set(new Uint8Array([0x05]), 1);
      time.set(new Uint8Array([0x9f]), 2);
      // const startTime = timeSlice.startTime || 0x0; //00:00 coded on 12bits
      // const endTime = timeSlice.endDate || 0x059F//23:59 coded on 12 bits
      // time.set(startTime);
      // time.set(endTime,12);
      tSlice.set(officeModeType);
      tSlice.set(week, 1);
      tSlice.set(time, 2);
      tSlices.set(tSlice, i);
    }

    let cmdData = new Uint8Array(2 + 5 * timeSlices.length);
    console.log('CmdData before:', cmdData);
    cmdData.set(officeMode);
    cmdData.set(tSliceCount, 1);
    cmdData.set(tSlices, 2);
    console.log('CmdData:', cmdData);
    let cmdLen = new Uint8Array([cmdData.length + 3]); //3 bytes for len, cmd word + checksum
    let cmdChecksum = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayClearEvents(): Promise<void> {
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x1b]);

    let cmdData = new Uint8Array(0);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayGetEventsCount(): Promise<void> {
    console.log('start rayGetEventsCount');
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x19]);

    let cmdData = new Uint8Array(0);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayGetEvent(seqNumber: number): Promise<void> {
    console.log('start rayGetEvent');
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x1a]);

    let cmdData = new Uint8Array(2);
    cmdData.set(this.int16ToBytesLE(seqNumber)); //Little/big endian ??

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayReadKeyCard(): Promise<void> {
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x29]);
    let waitingTime = new Uint8Array([10]); //waiting time in seconds

    let cmdData = new Uint8Array(1);
    cmdData.set(waitingTime);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayGetPermission(permissionId: string = '', typeNum: number = 2): Promise<void> {
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x21]);
    this.cmdCode = 0x21;
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);
    const type = new Uint8Array([typeNum]); //1=userId, 2=cardId, 3=password

    let id = new Uint8Array(6); //6 bytes userId, cardId or password
    id.set(this.hexStringToBytes(permissionId)); //Little endian?

    // const permId = id.reverse();
    const permId = id;

    let cmdData = new Uint8Array(7);
    cmdData.set(type);
    cmdData.set(permId, 1);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async raySetPermission(task, actionNum = 1): Promise<void> {
    /* permissionId: string = '',
     actionNum: number = 1,
     startDate: Date = new Date('2000-01-01T00:00:00Z'),
     endDate: Date = new Date('2100-01-01T00:00:00Z'),
     typeNum: number = 2) {*/

    task = task.params[0];

    let permissionId: string = task.value.keyCardNumber;
    let startDate: Date = new Date(task.value.start);
    let endDate: Date = new Date(task.value.end);

    console.log(
      JSON.stringify(new Date()),
      'Setting lock permission: id:',
      permissionId,
      'start:',
      startDate,
      'end:',
      endDate
    );
    if (!this.rayoComKey || !this.rayoIvCode) {
      console.log('Not authenticated!');
      return;
    }

    var typeNum = 2;

    /*if(typeNum === 2) {
      if(!this.tagId) {
        this.presentToast('Présentez un badge NFC et validez à nouveau');
      } else {
        permissionId = this.tagId;
      }
    }*/
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x22]);
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);
    const action = new Uint8Array([actionNum]); // 1=add/modiffy, 2=delete
    const type = new Uint8Array([typeNum]); //1=userId, 2=cardId, 3=password

    let id = new Uint8Array(6); //6 bytes userId, cardId or password
    id.set(this.hexStringToBytes(permissionId)); //Little endian?

    // const permId = id.reverse();
    const permId = id;
    const startTs = Math.floor(startDate.getTime() / 1000);
    const start = new Uint8Array(this.int32ToBytesLE(startTs));
    const endTs = Math.floor(endDate.getTime() / 1000);
    const end = new Uint8Array(this.int32ToBytesLE(endTs));

    const timeSlice = new Uint8Array([0xff]); //Bit 8 = sun, Bit 7 = mon,...Bit 2 = sat, Bit 1= calendar table (0 = disabled??)

    // const endTime = new Uint8Array(this.int32ToBytesLE(now+60));

    let cmdData = new Uint8Array(17);
    cmdData.set(action);
    cmdData.set(type, 1);
    cmdData.set(permId, 2);
    cmdData.set(start, 8);
    cmdData.set(end, 12);
    cmdData.set(timeSlice, 16);

    console.log('dataSeq : ', dataSeq);
    console.log('cmdCode : ', cmdCode);
    console.log('cmdData : ', cmdData);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayGetLockInfo(): Promise<void> {
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x0e]);

    let cmdData = new Uint8Array(0);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async raySetLockInfo(customConfig = {}) {
    //DataSeq = auth type (1 or 3=system key(not yet auth), 2=user com key (auth)
    let dataSeq = 2;
    let cmdCode = new Uint8Array([0x12]);

    const config = {
      building: 0,
      floor: 0,
      room: 0,
      lockType: 0,
      roomType: 0,
      lockReversalTime: 0,
      permissionMethod: 0,
      lockDisableFlag: 0,
      btBroadcastMode: 10,
      coreLockId: 0,
      autoCleanPerm: 0,
      autoCleanBlacklist: 0,
      buzzer: 0,
      light: 0,
      tamper: 0,
      tempPwd: 0
    };

    Object.assign(config, customConfig);

    const building = new Uint8Array([config.building]); //0 = not set
    const floor = new Uint8Array([config.floor]); //0 = not set
    const room = new Uint8Array([config.room]); //0 = not set
    const lockType = new Uint8Array([config.lockType]); //0 = not set, 1= room lock, 2= channel lock, 3 = special room lock 
    const roomType = new Uint8Array([config.roomType]); //0 = not set, special room type n° 1 -15
    const lockReversalTime = new Uint8Array([config.lockReversalTime]); //0 = not set, 1 -15
    const permissionMethod = new Uint8Array([config.permissionMethod]); //0 = not set, 0x1= card permissions, 0x2=lock permissions, 0x3= card + lock permissions
    const lockDisableFlag = new Uint8Array([config.lockDisableFlag]); //0= do not set 1= normal 2= deactivate
    const btBroadcastMode = new Uint8Array([config.btBroadcastMode]); //0= disable Blueooth, 1-100=broadcast interval (100ms unit)
    const coreLockId = this.int16ToBytesLE(config.coreLockId); //0 - 65535
    const autoCleanPerm = new Uint8Array([config.autoCleanPerm]); // 0=not set, 1= activated, 2=deactivated
    const autoCleanBlacklist = new Uint8Array(config.autoCleanBlacklist); // 0=not set, 1= activated, 2=deactivated
    const buzzer = new Uint8Array(config.buzzer); // 0=not set, 1= activated, 2=deactivated
    const light = new Uint8Array(config.light); // 0=not set, 1= activated, 2=deactivated
    const tamper = new Uint8Array(config.tamper); // 0=not set, 1= activated, 2=deactivated
    const tempPwd = new Uint8Array(config.tempPwd); // 0=not set, 1= activated, 2=deactivated

    let cmdData = new Uint8Array(17);

    cmdData.set(building);
    cmdData.set(floor, 1);
    cmdData.set(room, 2);
    cmdData.set(lockType, 3);
    cmdData.set(roomType, 4);
    cmdData.set(lockReversalTime, 5);
    cmdData.set(permissionMethod, 6);
    cmdData.set(lockDisableFlag, 7);
    cmdData.set(btBroadcastMode, 8);
    cmdData.set(coreLockId, 9);
    cmdData.set(autoCleanPerm, 11);
    cmdData.set(autoCleanBlacklist, 12);
    cmdData.set(buzzer, 13);
    cmdData.set(light, 14);
    cmdData.set(tamper, 15);
    cmdData.set(tempPwd, 16);

    return this.sendAndReadRayonics(dataSeq, cmdCode, cmdData, cmdData.length);
  }

  public async rayGetLockStatus() {
    if (!this.rayoComKey || !this.rayoIvCode) {
      console.log('Not authenticated!');
      // this.presentToast('Not authenticated!');
      return;
    }
    //cmd frame
    let cmdFrame = new Uint8Array(16);
    let dataFrame = new Uint8Array(20);

    let cmdCode = new Uint8Array([0x18]);
    // let userId = new Uint8Array([0x12,0x34,0x56,0x12,0x34,0x56]);

    let cmdData = new Uint8Array(0);
    // cmdData.set(startTime);
    // cmdData.set(endTime,4);
    let cmdLen = new Uint8Array([cmdData.length + 3]); //3 bytes for len, cmd word + checksum
    let cmdChecksum = this.xor(this.xor(cmdLen, cmdCode), cmdData);

    cmdFrame.set(cmdLen);
    cmdFrame.set(cmdCode, 1);
    // cmdFrame.set(cmdData,2);
    cmdFrame.set(cmdChecksum, 2);
    cmdFrame.set(new Uint8Array(13), 3); //frame content < 16bytes --> fill with 0

    let dataSN = new Uint8Array([0xff]);
    let dataSeq = new Uint8Array([0x02]);

    // let aesCbc = new aesjs.ModeOfOperation.cbc(new Uint8Array(16), new Uint8Array(16));
    let aesCbc = new aesjs.ModeOfOperation.cbc(this.rayoComKey, this.rayoIvCode);
    let cryptedCmdFrame = aesCbc.encrypt(cmdFrame);
    let dataCRCArr = new Uint8Array(dataSeq.length + cryptedCmdFrame.length);
    dataCRCArr.set(dataSeq);
    dataCRCArr.set(cryptedCmdFrame, 1);

    let dataCRC = this.int16ToBytesLE(this.crc16(dataCRCArr));

    // To print or store the binary data, you may convert it to hex
    //var encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);

    dataFrame.set(dataSN);
    dataFrame.set(dataSeq, 1);
    dataFrame.set(cryptedCmdFrame, 2);
    dataFrame.set(dataCRC, 18);

    console.log(
      'cmdFrame:',
      cmdFrame,
      'cryptedCmd:',
      cryptedCmdFrame,
      'dataFrame:',
      dataFrame,
      'comKey:',
      this.rayoComKey,
      'Iv:',
      this.rayoIvCode
    );
    // let dataFrame = new Uint8Array([255,1,255,220,203,230,104,239,225,109,162,251,231,28,203,232,18,23,23,233]);
    return this.sendRawDataWithResp(dataFrame);
  }

  async syncTasks(): Promise<void> {
    console.log('[DO TASK] START');

    console.log('currentTaskId : ', this.currentTaskId);
    console.log('currentCmdId : ', this.currentCmdId);
    // console.log(JSON.stringify(this.tasks));

    this.getTask = true;
    //this.changeRef.detectChanges();
    console.log(this.device);
    const task = this.tasks[this.currentTaskId];
    if (task == null || task == undefined) {
      console.log('[DO TASK] FINISHED');
      console.log('[DO TASK]', this.tasksToSend);

      this.tasksToSend = [
        ...new Map(this.tasksToSend.map((item) => [item['properties']['payload']['bytes']['data'], item])).values(),
      ];

      if (this.tasksToSend.length > 0)
        this.siteDeviceApi.siteDeviceConfirmTasks(this.device.id, this.tasksToSend).subscribe((response) => {
          console.log('[Task API] : ', response);
        });
      // setTimeout(() => this.rayGetLockInfo(), 500);
      this.getTask = false;
      // this.cmd = 'events';
      //this.changeRef.detectChanges();
      this.rayGetLockInfo();

      return;
    }
    //If no more command to process, proceed with next task
    if (this.tasks[this.currentTaskId].properties.payload.commands.length < this.currentCmdId) {
      console.log('TASK B');
      this.currentTaskId += 1;
      this.currentCmdId = 0;
      this.syncTasks();
      return;
    }

    this.paramsIsOk = false;
    let command = task.properties.payload.commands[this.currentCmdId];

    // console.log('currentTaskId : ', this.currentTaskId);
    // console.log('currentCmdId : ', this.currentCmdId);
    console.log(`Current Command (${this.currentCmdId}): ${JSON.stringify(command)}`);

    if (command == undefined) {
      console.log('undefined command');
      // boucle infinie si tâche avec aucune commande?
      this.currentCmdId += 1;
      this.syncTasks();
      return;
    }

    if (command.status == 'pending') {
      this.currentCmdId += 1;
      this.device.syncProgress = 0.5 * (this.currentTaskId / this.tasks.length) + 0.3;
      this.syncSubject.next({ device: this.device, status: 'sync' });
      this.cmdFromTask = true;
      let param;
      switch (command.commandType) {
        case 'openDoor':
          //this.useCmd('openDoor');
          break;
        case 'reset':
          this.rayResetLock();
          break;
        case 'writeParams':
          console.log('command type writeParams');
          if (!command.params || command.params.length < 1) {
            console.log('No params or misformed command params');
            // this.currentCmdId += 1;
            this.syncTasks();
            return;
          }
          param = command.params[0];
          if (!param || !param.type) {
            console.log('Misformed param or missing type');
            // this.currentCmdId += 1;
            this.syncTasks();
            return;
          }
          console.log('param:', JSON.stringify(param));
          switch (param.type) {
            case 'keyCard':
              // Add keycard in smartlock
              if (!param.index || !param.value || !param.value.keyCardNumber) {
                console.log('Misformed keyCard param:', param);
                // this.currentCmdId += 1;
                this.syncTasks();
                return;
              }
              //First, send keycard to smartlock with given keyCardNumber
              this.paramIndex = param.index;
              const keyCardNumber = param.value.keyCardNumber;
              const revKeyCardNumber = keyCardNumber.match(/../g).reverse().join('');
              console.log('Sending create command for keycard:', keyCardNumber);
              this.raySetPermission(command);

              console.log('KeyCardNumber:', keyCardNumber, typeof keyCardNumber);
              //If reverse keyCard number has already been generated, just send
              //the permission
              if (
                this.keyCardReverse.hasOwnProperty(revKeyCardNumber) &&
                this.keyCardReverse[revKeyCardNumber] === true
              ) {
                console.log('Keycard already sent, sending reverse number');
                break;
              }
              //Else we generate the reverse keyCard number
              //Temporary fix to handle reversed keycard numbers
              //(add both normal and reversed number in smartlock)
              console.log('KeyCard sent for the first time, generating reverse command');
              //Pb doublon revCOmmand
              let revCommand = { ...command };
              revCommand.params[0].value.keyCardNumber = revKeyCardNumber;
              console.log('revcommand', JSON.stringify(revCommand));
              this.tasks[this.currentTaskId].properties.payload.commands.splice(this.currentCmdId - 1, 0, revCommand);
              // console.log(JSON.stringify(this.tasks));
              this.keyCardReverse[keyCardNumber] = true;
              return;
            case 'reset':
              this.rayResetLock();
              return;
            default:
              console.log('Type', param.type, 'not yet handled');
              // this.currentCmdId += 1;
              this.syncTasks();
              return;
          }
          break;
        //on arrive ici alors que commandType != deletePArams!!!???
        case 'deleteParams':
          console.log('command type deleteParams:', JSON.stringify(command));
          if (!command.params || command.params.length < 1) {
            console.log('No params or misformed command params');
            // this.currentCmdId += 1;
            this.syncTasks();
            break;
          }
          param = command.params[0];
          if (!param || !param.type) {
            console.log('Misformed param or missing type');
            // this.currentCmdId += 1;
            this.syncTasks();
            break;
          }
          console.log('param:', JSON.stringify(param));
          switch (param.type) {
            case 'keyCard':
              // Add keycard in smartlock
              if (!param.index || !param.value || !param.value.keyCardNumber) {
                console.log('Misformed keyCard param:', param);
                // this.currentCmdId += 1;
                this.syncTasks();
                break;
              }
              //First, send keycard to smartlock with given keyCardNumber
              this.paramIndex = param.index;
              const keyCardNumber = param.value.keyCardNumber;
              const revKeyCardNumber = keyCardNumber.match(/../g).reverse().join('');
              console.log('Sending delete command for keycard:', keyCardNumber);
              this.raySetPermission(command, 2);
              //If reverse keyCard number has already been generated, just send
              //the permission
              console.log('KeyCardNumber:', keyCardNumber, typeof keyCardNumber);
              if (this.keyCardReverse.hasOwnProperty(revKeyCardNumber) && this.keyCardReverse[revKeyCardNumber]) {
                console.log('Keycard already deleted, deleting reverse number');
                break;
              }
              //Else we generate the reverse keyCard number
              //Temporary fix to handle reversed keycard numbers
              //(add both normal and reversed number in smartlock)
              console.log('KeyCard deleted for the first time, generating reverse command');
              let revCommand = { ...command };
              revCommand.params[0].value.keyCardNumber = revKeyCardNumber;
              console.log('revcommand', revCommand);
              this.tasks[this.currentTaskId].properties.payload.commands.splice(this.currentCmdId - 1, 0, revCommand);
              this.keyCardReverse[keyCardNumber] = true;
              return;
            default:
              console.log('Type', param.type, 'not yet handled');
              // this.currentCmdId += 1;
              this.syncTasks();
              break;
          }
          break;
        default:
          break;
      }
    } else {
      console.log('command status not pending, process next command');
      this.currentCmdId += 1;
      this.syncTasks();
    }

    console.log('[DO TASK] END');
  }

  public async update(): Promise<any> {
    console.log('Updating device', this.device.bleId);
    this.isUpdating = true;
    this.storage.set('fromScan', true);
    const url = 'https://storage.gra.cloud.ovh.net/v1/AUTH_9d177826801d427c9e69e0ec2e22422a/rayonics_firmwares/rayo_hw101_latest.zip';
    this.HTTP.sendRequest(url, { method: 'get', responseType: 'blob' })
      .then(async (res) => {
        console.log('Dfu update - http response:', res);
        // const base64 = await this.blobToBase64(res.data);
        // const base64 = await readBlobAsBase64(res.data);
        const blob: Blob = res.data;
        const writeRes = await write_blob({
          path: 'rayo_hw101_latest.zip',
          directory: Directory.Data,
          blob: blob
        });
        console.log('writeBlob:', writeRes);
        try {
          // const file = await Filesystem.writeFile({
          //   path:'rayo_hw101_sw122.zip',
          //   directory:Directory.Documents,
          //   data: blob.toString(),
          //   // encoding: null
          // });
          // const uri = file.uri;
          const uri = (await Filesystem.getUri({ path: 'rayo_hw101_latest.zip', directory: Directory.Data })).uri;
          console.log('Update file url:', uri);
          // const url = 'file://';
          const options = { fileUrl: uri, deviceId: this.device.bleId };
          try {
            const myObserver = {
              next: (x: any) => {
                console.log('DFU update next value: ', x);
                switch (x.status) {
                  case 'deviceConnected':
                    this.device.syncProgress = 0.21;
                    break;
                  case 'progressChanged':
                    const p = Math.round((x.progress.percent - 1)) / 100;
                    this.device.syncProgress = p <= 0.22 ? 0.22 : p;
                    break;
                  case 'dfuCompleted':
                    this.device.syncProgress = 1;
                    this.syncSubject.next({ status: 'update_end', device: this.device });
                    break;
                  case 'deviceDisconnecting':
                    // if(this.device.id === 541 || this.device.id === 548) {
                    //   this.device.syncProgress = 1;
                    //   this.syncSubject.next({status:'update_end',device:this.device});
                    // }
                    break;
                }
                this.syncSubject.next({ device: this.device, status: 'update' });
              },
              error: (err: Error) => {
                console.error('DFU update error: ', err);
                this.syncSubject.next({ device: this.device, status: 'update_error' });
              },
              // complete: async () => {
              //   console.log('DFU update complete');
              //   this.syncSubject.next({device: this.device, status: 'update_end'});
              // },
            };
            this.dfuUpdate.updateFirmware(options)
              .subscribe(myObserver);
            // .subscribe((res) => console.log('DFU updateFirmware next:',res));
          } catch (e) {
            console.log('Error in dfu updateFirmware function:', e);
          }
        } catch (err) {
          console.log('Error while writing firmware file to disk', err)
        };
        console.log('Dfu update started');
      })
      .catch((err) => {
        console.log('DFU update - error while downloading FW file', err);
      });
    // const path = 'file://../../../../assets/files/rayo_hw101_sw122.zip';
    // const path = 'src/assets/files/rayo_hw101_sw122.zip';
    // this.filePath.resolveNativePath(path)
    // .then((url) => {
    // })
    // .catch(err => {
    //   console.log('Error while getting rayonics update filePath',err);
    //   return false;
    // })
  }

  public async recreateDeviceConfig(oldDevice: any, newDevice: any = null, changeKeys = false): Promise<any> {
    console.log('RayoBleService - recreateDeviceConfig; oldDevice:',
    oldDevice,'newDevice:',newDevice,'changeKeys:',changeKeys)
    if(!newDevice) newDevice = oldDevice;
    const btBroadcastMode = oldDevice.properties.config?.btBroadcastMode ?? 10;
    const newConfig = {btBroadcastMode: btBroadcastMode};
    await this.raySetLockInfo(newConfig);
    this.delay(1000);
    return new Promise((resolve, reject) => {
      this.deviceApi.deviceControllerFindDeviceAccesses(oldDevice.id).subscribe((accessIds: any) => {
        console.log('recreateDeviceConfig - findAccesses:', accessIds)
        if (accessIds?.length > 0) {
          this.deviceApi.deviceControllerCreateDeviceAccesses(newDevice.id, accessIds, 'response')
            .subscribe(async (res) => {
              console.log(res);
              if (res?.status === 204) {
                console.log('Accesses recreated on device', newDevice.id);
                if(!changeKeys) return resolve(true);
                //If needed, transfer old Keys to new Device (ex when replacing cylinder head)
                if(oldDevice.properties?.ivCodeStr !== newDevice.properties?.ivCodeStr
                  || oldDevice.properties?.systemKeyStr !== newDevice.properties?.systemKeyStr
                  || oldDevice.properties?.regCodeStr !== newDevice.properties?.regCodeStr) {
                    await this.rayChangeKeys(false,{
                      ivCodeStr: oldDevice.properties.ivCodeStr,
                      systemKeyStr: oldDevice.properties.systemKeyStr,
                      regCodeStr: oldDevice.properties.regCodeStr,
                    })
                    this.delay(500);
                    return resolve(true);
                  }
                resolve(true);
              } else {
                reject(res);
              }
            });
        } else {
          console.log('No accesses to recreate on device', newDevice.id);
          resolve(true);
        }
      });
    });
  }

  public async blobToBase64(blob: Blob): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader;
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  public async sendEventsToApi(): Promise<void> {
    this.deviceApi
      .siteDeviceAddEventAll(this.device.id, this.eventsList)
      .toPromise()
      .then((res) => {
        console.log('Send Event to API : ', res);
        this.rayClearEvents();
        this.syncSubject.next({ device: this.device, status: 'end' });
        // this.syncEnd = true;
        // this.stopInput = false;
        this.eventsList = [];
        // this.doRefresh();
        // if (!this.changeRef['destroyed']) {
        //   this.changeRef.detectChanges();
        // }
      })
      .catch((err) => {
        console.log('Error while sending events to API:', err);
        this.syncSubject.next({ device: this.device, status: 'events_error' });
        // this.syncEnd = true;
        // this.stopInput = false;
        // this.doRefresh();
        // if (!this.changeRef['destroyed']) {
        //   this.changeRef.detectChanges();
        // }
      });
  }
}
